module.exports = __webpack_public_path__ + "components/MapControl/svg/Uczelnia wyższa.svg?40ab333b";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Uczelnia wyższa.svg
// module id = 2044
// module chunks = 0